import { render } from "./AutoLink.vue?vue&type=template&id=0b36f660&scoped=true"
import script from "./AutoLink.vue?vue&type=script&lang=js"
export * from "./AutoLink.vue?vue&type=script&lang=js"

import "./AutoLink.vue?vue&type=style&index=0&id=0b36f660&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b36f660"]])

export default __exports__